import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { FeedbackComponent } from './components/feedbackComponent';

export const feedbackPlugin = createPlugin({
  id: 'techdocs-addon-feedback',
});

export const FeedbackAddon = feedbackPlugin.provide(
  createTechDocsAddonExtension({
    name: 'Feedback',
    location: TechDocsAddonLocations.Content,
    component: FeedbackComponent,
  }),
);
